// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"502":"dec4c112","5540":"b3c6cffc","6050":"d994bb9d"}[chunkId] + ".chunk.css";
};